// extracted by mini-css-extract-plugin
export default {"listFav":"styles_listFav__Lgeua","itemsList":"styles_itemsList__iyDC4"};